import { Bot } from 'lucide-react';
import BotAccessForm from '../../../components/BotAccessForm';
import InfoTip from '../../../components/InfoTip';

export default function BotAccessSection({ domain }) {
  return (
    <div className="card">
      <div className="section-header">
        <div className="section-title">
          <span className="section-icon">
            <Bot className="w-4 h-4" />
          </span>
          AI bot access
          <InfoTip
            title="Allow vs. block"
            body="If you want AI engines to quote your site, ALLOW the corresponding bot. Examples: ChatGPT cites pages crawled by GPTBot; Claude needs ClaudeBot; Gemini training uses Google-Extended. Blocking a bot doesn't hide you from AI — but it does prevent that engine from using your latest content."
          />
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-3">
        Toggle which AI crawlers we allow / log for this domain. Allow them if you want
        the matching AI engine to quote your latest content; block to keep your site out
        of that engine&apos;s training data. Blocked bots are still recorded so you can
        see when one tried to visit.
      </p>
      <BotAccessForm domainId={domain._id} />
    </div>
  );
}
